import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=c8578ef4&scoped=true&"
import script from "./integrations.vue?vue&type=script&lang=js&"
export * from "./integrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8578ef4",
  null
  
)

export default component.exports